"use client";

import { TitleH3 } from "@/components/shared/public";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { logoImmoMates } from "../../../../../public/images/logos";

const ContactDetails = () => {
  const t = useTranslations("common");
  const tI = useTranslations("imprint");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-10">
        <div className="flex flex-col justify-between lg:flex-row lg:items-center">
          <div className="text-ring flex flex-col gap-5 text-lg">
            <TitleH3 title={t("responsible")} />

            <div>
              <p>ImmoMates GmbH</p>
              <p>{t("ceo")}: Jan Heusinger</p>
              <p>Lange Reihe 22</p>
              <p>20099 Hamburg</p>
            </div>

            <div>
              <p>{t("localCourt")}</p>
              <p>HRB 162124</p>
            </div>

            <div>
              <p>Telefon: 040 69639190</p>
              <p>E-Mail: mail@grundriss-schmiede.de</p>
            </div>

            <p>USt-ID-Nr.: DE329099286</p>
          </div>
          <div className="text-ring flex flex-col gap-2 text-lg">
            <p>{tI("brandOf")}</p>
            <Link
              href="https://www.immomates.de/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={logoImmoMates}
                alt={"Logo ImmoMates GmbH"}
                className="lg:w-[540px]"
              />
            </Link>
          </div>
        </div>

        <div className="text-ring flex flex-col gap-10 text-lg">
          <p>
            {tI("disputeResolution")}{" "}
            <Link
              className="hover:text-primary font-medium hover:underline"
              href="https://ec.europa.eu/consumers/odr/finden"
            >
              https://ec.europa.eu/consumers/odr/finden
            </Link>
            .
          </p>
          <div className="flex flex-col gap-5">
            <TitleH3 title={tI("disclaimer")} />
            <p>{tI("disclaimerText")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
